// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/az_partner",
    element: lazy(() => import("../pages/AffiliateTemplate/index")),
  },
  {
    path: "/az_partner/view/:affiliate",
    element: lazy(() => import("../pages/AffiliateTemplate/AffiliateView")),
  },
  {
    path: "/az_partner/view/pending_finance/:affiliate",
    element: lazy(() => import("../pages/AffiliateTemplate/PaymentDetails")),
  },

  {
    path: "/az_partner/view/pending_allocation/:affiliate",
    element: lazy(() => import("../pages/AffiliateTemplate/AllocationDetails")),
  },

  {
    path: "/az_partner/view/topup_review/:affiliate",
    element: lazy(() => import("../pages/AffiliateTemplate/PaymentDetails")),
  },

  {
    path: "/az_partner/view/affiliate-report/:affiliate/:type",
    element: lazy(() => import("../pages/AffiliateTemplate/AffiliateReport")),
  },
  {
    path: "/az_partner/EditAffiliate/:affiliateId",
    element: lazy(() => import("../pages/AffiliateTemplate/EditAffiliate")),
  },
];

export default routes;
